<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1300"
  >
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      :title="'Email ' + documentType"
      text="Please input and check the employees' email"
      class="mb-0"
    > 
      <v-form
        v-if="dialog"
        data-simplebar
        class="overflow"
      >
        <v-container>
          <v-row
            no-gutters
            class="mt-3 red--text text-uppercase"
          >
            <v-icon
              class="pr-1"
              color="red"
            >
              mdi-information-outline
            </v-icon>
            Kindly note that the sent {{ documentType }} will not be resend unless cancel released and release before able to send via email again.
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-card class="pb-2 mb-5 elevation-0">
                <v-row class="font-weight-bold font-16 border-bottom-light-grey">
                  <v-col cols="1">
                    Employee ID
                  </v-col>
                  <v-col cols="4">
                    Name
                  </v-col>
                  <v-col cols="4">
                    Payroll Company
                  </v-col>
                  <v-col cols="3">
                    Email
                  </v-col>
                </v-row>
        
                <v-row
                  v-for="(companyEmployee, index) in companyEmployees"
                  :key="index"
                  no-gutters
                  :class="{'alternate-row': index % 2 === 0 }"
                >
                  <v-col
                    cols="1"
                    class="ma-auto"
                  >
                    {{ (employeeNumberStarter||{}).value }}{{ companyEmployee.employee.employee_number }} 
                  </v-col>

                  <v-col
                    cols="4"
                    class="ma-auto"
                  >
                    {{ companyEmployee.employee.person.name }}
                  </v-col>

                  <v-col
                    cols="4"
                    class="ma-auto"
                  >
                    {{ companyEmployee.company.name }}
                  </v-col>

                  <v-col
                    cols="3"
                    class="ma-auto"
                  >
                    <v-combobox
                      v-model="companyEmployees[index].emails[0]"
                      v-validate="'required|email'"
                      :error-messages="errors.collect('email' + index)"
                      :name="'email' + index"
                      data-vv-as="email"
                      class="ma-0 dropdownHeight"
                      dense
                      :items="companyEmployee.emails"
                      flat
                      hide-no-data
                      hide-selected
                      append-icon=""
                      :hide-details="true"
                    />
                    <div v-if="errors.first('email' + index)">
                      <span class="red--text text--lighten-1 caption">{{ errors.first('email' + index) }}</span>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"
          class="white--text px-5"
          @click="confirmation"
        >
          Email {{ documentType }}
        </v-btn>
      </v-card-actions>
      <payroll-dialog-email-confirmation
        ref="showEmailConfirmationWindow"
        @email="submitForm"
      />
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      PayrollDialogEmailConfirmation: () => import('@/components/hris/payroll/DialogEmailConfirmation'),
    },
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      documentType: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        dataPreparation: null,
        dialog: false,
        confirmationDialog: false,
        progressing: false,
        companyEmployees: [],
        companyEmployeeUids: [],
        employeeNumberLengthSetting: [],
        employeeNumberStarter: [],
      }
    },

    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()
        
        this.dataPreparation.selectedCompanyEmployees.forEach(data => {
          if (!data.payslip_sent_by_email && !data.is_email_sent) {
            this.companyEmployeeUids.push(data.company_employee_uid)
          }
        })

        this.loadSystemSettings()
        this.loadData()
      },
    }, 

    methods: { 
      confirmation () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            this.$refs.showEmailConfirmationWindow.toggleDialog()
          })
      },
      loadSystemSettings () {
        this.$api.systemSettings().list()
          .then((res) => {
            this.employeeNumberLengthSetting = res.data.find(setting => 
              setting.key === 'EMPLOYEE_NUMBER_LENGTH'
            )
            this.employeeNumberStarter = res.data.find(setting => 
              setting.key === 'EMPLOYEE_NUMBER_STARTER'
            )
          })
          .catch(() => {})
      },
      loadData () {
        this.$api.hrisCompanyEmployees().getEmail(this.companyEmployeeUids)
          .then(res => {
            this.companyEmployees = res.data
            
            this.companyEmployees = _.orderBy(this.companyEmployees, ['employee.person.name'], ['asc'])

            this.companyEmployees.forEach(companyEmployee => {
              let emails = []

              if (companyEmployee.employee && companyEmployee.employee.employee_number) {
                // preset 10 digits of 0
                companyEmployee.employee.employee_number = '0000000000' + companyEmployee.employee.employee_number 
                // cut the digits based on EMPLOYEE_NUMBER_LENGTH setting
                companyEmployee.employee.employee_number = companyEmployee.employee.employee_number.substring(companyEmployee.employee.employee_number.length - this.employeeNumberLengthSetting.value, companyEmployee.employee.employee_number.length)
              }

              if (companyEmployee.employee.person.personal_email_address) {
                emails.push(companyEmployee.employee.person.personal_email_address)
              }
              if (companyEmployee.employee.email && 
                (!companyEmployee.employee.end_date || this.$moment(companyEmployee.employee.end_date).format('YYYY-MM-DD') > this.$moment().format('YYYY-MM-DD'))
              ) {
                emails.push(companyEmployee.employee.email)
              }

              companyEmployee.emails = emails
            })
            
            this.progressing = false
          })
      },
      toggleDialog (data) {
        this.dataPreparation = data
        this.dialog = true
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true
            this.isEmail = true

            let api = ''

            if (this.documentType === 'Payslip') {
              api = this.$api.payslips().emailPayslip(this.prepareFormData())
            } else { // EA Form
              api = this.$api.payrollReports().emailEmployeeEa(this.prepareFormData())
            }

            api.then(res => {
              this.$snack({ message: this.documentType + ' email successfully' })
              this.$emit('emailed')
              this.dialog = false
            })
              .catch((err) => {
                if (err.response.status === 422 && err.response.data.status) {              
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.status, 
                  })
                } else this.$snack({ color: 'error', message: 'Unable to email' })
              })
              .then(() => {
                this.progressing = false
                this.isEmail = false
              })
          })
      },
      prepareFormData () {
        if (this.documentType === 'Payslip') {
          return {
            companyEmployees: this.companyEmployees,
            payroll_period_id: this.dataPreparation.payroll_period_id,
            payroll_cycle_transaction_id: this.dataPreparation.payroll_cycle_transaction_id,
          }
        } else { // EA Form
          return {
            year: this.dataPreparation.year,
            companyEmployees: this.companyEmployees,
          }
        }
      },      
    },
  }
</script>

<style scoped>
.dropdownHeight >>> .v-input__control .v-input__slot{
  height:26px !important;
}
.dropdownHeight >>> .v-input__control{
  height:26px !important;
}
.dropdownHeight >>> .v-input__control .v-input__slot::before{
  border:unset !important;
}
.alternate-row{
  background-color: #e6e6e6;
}
.overflow {
  max-height:45vh;
}
</style>
